
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18wu0_u2y66_3",
  "box": "awsui_box_18wu0_u2y66_16",
  "p-variant": "awsui_p-variant_18wu0_u2y66_16",
  "color-default": "awsui_color-default_18wu0_u2y66_16",
  "b-variant": "awsui_b-variant_18wu0_u2y66_16",
  "strong-variant": "awsui_strong-variant_18wu0_u2y66_16",
  "code-variant": "awsui_code-variant_18wu0_u2y66_16",
  "pre-variant": "awsui_pre-variant_18wu0_u2y66_16",
  "samp-variant": "awsui_samp-variant_18wu0_u2y66_16",
  "h1-variant": "awsui_h1-variant_18wu0_u2y66_20",
  "h2-variant": "awsui_h2-variant_18wu0_u2y66_20",
  "h3-variant": "awsui_h3-variant_18wu0_u2y66_20",
  "h4-variant": "awsui_h4-variant_18wu0_u2y66_20",
  "h5-variant": "awsui_h5-variant_18wu0_u2y66_20",
  "small-variant": "awsui_small-variant_18wu0_u2y66_24",
  "a-variant": "awsui_a-variant_18wu0_u2y66_28",
  "font-size-default": "awsui_font-size-default_18wu0_u2y66_32",
  "font-weight-default": "awsui_font-weight-default_18wu0_u2y66_72",
  "key-label-variant": "awsui_key-label-variant_18wu0_u2y66_112",
  "value-large-variant": "awsui_value-large-variant_18wu0_u2y66_117",
  "color-inverted": "awsui_color-inverted_18wu0_u2y66_125",
  "color-text-label": "awsui_color-text-label_18wu0_u2y66_128",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_u2y66_131",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_u2y66_134",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_u2y66_137",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_u2y66_140",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_u2y66_143",
  "color-inherit": "awsui_color-inherit_18wu0_u2y66_146",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_u2y66_149",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_u2y66_154",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_u2y66_158",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_u2y66_162",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_u2y66_167",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_u2y66_172",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_u2y66_177",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_u2y66_182",
  "font-weight-light": "awsui_font-weight-light_18wu0_u2y66_187",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_u2y66_190",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_u2y66_193",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_u2y66_196",
  "t-left": "awsui_t-left_18wu0_u2y66_200",
  "t-right": "awsui_t-right_18wu0_u2y66_204",
  "t-center": "awsui_t-center_18wu0_u2y66_208",
  "p-n": "awsui_p-n_18wu0_u2y66_215",
  "p-top-n": "awsui_p-top-n_18wu0_u2y66_219",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_u2y66_220",
  "p-right-n": "awsui_p-right-n_18wu0_u2y66_224",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_u2y66_225",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_u2y66_229",
  "p-left-n": "awsui_p-left-n_18wu0_u2y66_234",
  "p-xxxs": "awsui_p-xxxs_18wu0_u2y66_239",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_u2y66_243",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_u2y66_244",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_u2y66_248",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_u2y66_249",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_u2y66_253",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_u2y66_258",
  "p-xxs": "awsui_p-xxs_18wu0_u2y66_263",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_u2y66_267",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_u2y66_268",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_u2y66_272",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_u2y66_273",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_u2y66_277",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_u2y66_282",
  "p-xs": "awsui_p-xs_18wu0_u2y66_287",
  "p-top-xs": "awsui_p-top-xs_18wu0_u2y66_291",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_u2y66_292",
  "p-right-xs": "awsui_p-right-xs_18wu0_u2y66_296",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_u2y66_297",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_u2y66_301",
  "p-left-xs": "awsui_p-left-xs_18wu0_u2y66_306",
  "p-s": "awsui_p-s_18wu0_u2y66_311",
  "p-top-s": "awsui_p-top-s_18wu0_u2y66_315",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_u2y66_316",
  "p-right-s": "awsui_p-right-s_18wu0_u2y66_320",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_u2y66_321",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_u2y66_325",
  "p-left-s": "awsui_p-left-s_18wu0_u2y66_330",
  "p-m": "awsui_p-m_18wu0_u2y66_335",
  "p-top-m": "awsui_p-top-m_18wu0_u2y66_339",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_u2y66_340",
  "p-right-m": "awsui_p-right-m_18wu0_u2y66_344",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_u2y66_345",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_u2y66_349",
  "p-left-m": "awsui_p-left-m_18wu0_u2y66_354",
  "p-l": "awsui_p-l_18wu0_u2y66_234",
  "p-top-l": "awsui_p-top-l_18wu0_u2y66_363",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_u2y66_364",
  "p-right-l": "awsui_p-right-l_18wu0_u2y66_368",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_u2y66_369",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_u2y66_373",
  "p-left-l": "awsui_p-left-l_18wu0_u2y66_378",
  "p-xl": "awsui_p-xl_18wu0_u2y66_383",
  "p-top-xl": "awsui_p-top-xl_18wu0_u2y66_387",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_u2y66_388",
  "p-right-xl": "awsui_p-right-xl_18wu0_u2y66_392",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_u2y66_393",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_u2y66_397",
  "p-left-xl": "awsui_p-left-xl_18wu0_u2y66_402",
  "p-xxl": "awsui_p-xxl_18wu0_u2y66_407",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_u2y66_411",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_u2y66_412",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_u2y66_416",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_u2y66_417",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_u2y66_421",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_u2y66_426",
  "p-xxxl": "awsui_p-xxxl_18wu0_u2y66_431",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_u2y66_435",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_u2y66_436",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_u2y66_440",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_u2y66_441",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_u2y66_445",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_u2y66_450",
  "m-n": "awsui_m-n_18wu0_u2y66_455",
  "m-top-n": "awsui_m-top-n_18wu0_u2y66_459",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_u2y66_460",
  "m-right-n": "awsui_m-right-n_18wu0_u2y66_464",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_u2y66_465",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_u2y66_469",
  "m-left-n": "awsui_m-left-n_18wu0_u2y66_474",
  "m-xxxs": "awsui_m-xxxs_18wu0_u2y66_479",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_u2y66_483",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_u2y66_484",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_u2y66_488",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_u2y66_489",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_u2y66_493",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_u2y66_498",
  "m-xxs": "awsui_m-xxs_18wu0_u2y66_503",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_u2y66_507",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_u2y66_508",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_u2y66_512",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_u2y66_513",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_u2y66_517",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_u2y66_522",
  "m-xs": "awsui_m-xs_18wu0_u2y66_527",
  "m-top-xs": "awsui_m-top-xs_18wu0_u2y66_531",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_u2y66_532",
  "m-right-xs": "awsui_m-right-xs_18wu0_u2y66_536",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_u2y66_537",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_u2y66_541",
  "m-left-xs": "awsui_m-left-xs_18wu0_u2y66_546",
  "m-s": "awsui_m-s_18wu0_u2y66_551",
  "m-top-s": "awsui_m-top-s_18wu0_u2y66_555",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_u2y66_556",
  "m-right-s": "awsui_m-right-s_18wu0_u2y66_560",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_u2y66_561",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_u2y66_565",
  "m-left-s": "awsui_m-left-s_18wu0_u2y66_570",
  "m-m": "awsui_m-m_18wu0_u2y66_575",
  "m-top-m": "awsui_m-top-m_18wu0_u2y66_579",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_u2y66_580",
  "m-right-m": "awsui_m-right-m_18wu0_u2y66_584",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_u2y66_585",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_u2y66_589",
  "m-left-m": "awsui_m-left-m_18wu0_u2y66_594",
  "m-l": "awsui_m-l_18wu0_u2y66_474",
  "m-top-l": "awsui_m-top-l_18wu0_u2y66_603",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_u2y66_604",
  "m-right-l": "awsui_m-right-l_18wu0_u2y66_608",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_u2y66_609",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_u2y66_613",
  "m-left-l": "awsui_m-left-l_18wu0_u2y66_618",
  "m-xl": "awsui_m-xl_18wu0_u2y66_623",
  "m-top-xl": "awsui_m-top-xl_18wu0_u2y66_627",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_u2y66_628",
  "m-right-xl": "awsui_m-right-xl_18wu0_u2y66_632",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_u2y66_633",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_u2y66_637",
  "m-left-xl": "awsui_m-left-xl_18wu0_u2y66_642",
  "m-xxl": "awsui_m-xxl_18wu0_u2y66_647",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_u2y66_651",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_u2y66_652",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_u2y66_656",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_u2y66_657",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_u2y66_661",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_u2y66_666",
  "m-xxxl": "awsui_m-xxxl_18wu0_u2y66_671",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_u2y66_675",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_u2y66_676",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_u2y66_680",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_u2y66_681",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_u2y66_685",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_u2y66_690",
  "d-block": "awsui_d-block_18wu0_u2y66_695",
  "d-inline": "awsui_d-inline_18wu0_u2y66_698",
  "d-inline-block": "awsui_d-inline-block_18wu0_u2y66_701",
  "d-none": "awsui_d-none_18wu0_u2y66_704",
  "f-left": "awsui_f-left_18wu0_u2y66_708",
  "f-right": "awsui_f-right_18wu0_u2y66_712"
};
  